import { defineNuxtPlugin, defineNuxtRouteMiddleware, navigateTo } from '#app'
import { useAuth0 } from '@auth0/auth0-vue'
import { unref } from 'vue'

export default defineNuxtRouteMiddleware((to, from) => {
    // See https://auth0.github.io/auth0-vue/functions/useAuth0.html for API
    const client = useAuth0();
    console.log('modules/nuxtAuth/runtime/createAuthRouterGuard/defineNuxtRouteMiddleware::isAuthenticated: ', client?.isAuthenticated?.value);
    console.log('modules/nuxtAuth/runtime/createAuthRouterGuard/defineNuxtRouteMiddleware::user: ', client?.user?.value);

    // Using the logic from https://github.com/auth0/auth0-vue/blob/main/src/guard.ts#L10
    if (!unref(client.isAuthenticated)) {
        return navigateTo('/');
    }
})
